import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import AssessmentModalLayout from 'bundles/compound-assessments/components/modals/AssessmentModalLayout';
import TimeDuration from 'bundles/phoenix/components/TimeDuration';

import _t from 'i18n!nls/compound-assessments';

export type Props = {
  nextAttemptDuration?: number | null;
  nextAttemptSubmissionLimit?: number | null;
  showRestartConfirmation?: boolean | null;
  onPrimaryButtonClick: () => void;
  onCancelButtonClick: () => void;
};

const StartAttemptModal = ({
  showRestartConfirmation,
  nextAttemptDuration,
  nextAttemptSubmissionLimit,
  onPrimaryButtonClick,
  onCancelButtonClick,
}: Props) => {
  return (
    <AssessmentModalLayout
      title={_t('Start new attempt?')}
      content={
        <div>
          {showRestartConfirmation && (
            <div>
              <Typography2 variant="bodyPrimary" component="p">
                {_t(
                  'When you submit your new attempt, it will replace your previous submission. If you do not submit the new attempt, your previous submission will be graded.'
                )}
              </Typography2>
            </div>
          )}
          {nextAttemptDuration ? (
            <div>
              <Typography2 variant="bodyPrimary" component="p">
                <FormattedMessage
                  message={
                    nextAttemptSubmissionLimit
                      ? _t(
                          'You have {timeDuration} to submit up to {submissions, plural, =1 {# time} other {# times}} for this attempt.'
                        )
                      : _t('You have {timeDuration} to submit unlimited times for this attempt.')
                  }
                  timeDuration={<TimeDuration duration={nextAttemptDuration} showPrecise={true} />}
                  submissions={nextAttemptSubmissionLimit}
                />
              </Typography2>
              <Typography2 variant="bodyPrimary" component="p">
                {_t('The time limit might change if the availability window ends earlier.')}
              </Typography2>
            </div>
          ) : (
            <Typography2 variant="bodyPrimary" component="p">
              {_t('Are you sure you want to start another attempt?')}
            </Typography2>
          )}
        </div>
      }
      primaryButtonContents={_t('Continue')}
      cancelButtonContents={_t('Cancel')}
      hideCancelButton={false}
      onPrimaryButtonClick={onPrimaryButtonClick}
      onCancelButtonClick={onCancelButtonClick}
    />
  );
};

export default StartAttemptModal;
